import styled from '@emotion/styled';

const NotFoundText = styled('p')({
  marginBottom: 24,
  opacity: 0.7
});

export default NotFoundText;
